import { render, staticRenderFns } from "./SecondTag.vue?vue&type=template&id=52a2124d&scoped=true&"
import script from "./SecondTag.vue?vue&type=script&lang=js&"
export * from "./SecondTag.vue?vue&type=script&lang=js&"
import style0 from "./SecondTag.vue?vue&type=style&index=0&id=52a2124d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2124d",
  null
  
)

export default component.exports